import moment from "moment";

const formatDate = (date?: string | null) => {
  if (!date) return "N/A";
  return moment.utc(date).local().format("D MMM · h:mm A");
};

export default formatDate;
